import type { FC, MouseEventHandler } from 'react';
import type { ResourceBlock } from '@domain/schemas/contract.schema';

import { useContractBlockActions } from '../hooks/useContractBlockActions';
import { ContractBlockActionsView } from '../views/ContractBlockActionsView';

interface ContractBlockActionsControllerProps {
  block: ResourceBlock;
  handleDelete: MouseEventHandler;
  handleEdit: MouseEventHandler<HTMLDivElement>;
}

export const ContractBlockActionsController: FC<ContractBlockActionsControllerProps> = ({
  block,
  handleDelete,
  handleEdit,
}) => {
  const viewProps = useContractBlockActions(block);
  return <ContractBlockActionsView {...viewProps} onDelete={handleDelete} onEdit={handleEdit} />;
};
